module.exports = __webpack_public_path__ + "static/media/features_search.d41e7bff.svg";